import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import Auction from './Auction';
import ArtUploader from './ArtUploader';
import reportWebVitals from './reportWebVitals';
import get_web3_provider from './utils.js';
import contractAbi from './abi/ArtifexAuction.json';

if (typeof window.wpApiSettings === 'undefined') {
  window.wpApiSettings = { nonce: null,
                           auctionContract: process.env.REACT_APP_AUCTION_CONTRACT,
                           rpcUrl: 'http://localhost:8545',
                           wpApiUrl: 'http://localhost:8000/index.php/wp-json/',
  };
}
console.log(window.wpApiSettings);

const rpcUrl = window.wpApiSettings.rpcUrl;
const web3 = get_web3_provider(rpcUrl);
const auctionContract = new web3.eth.Contract(contractAbi.abi, window.wpApiSettings.auctionContract);

const renderComponent = (component, id, props) => {
  const element = document.getElementById(id);
  if (element) {
    const root = ReactDOM.createRoot(element);
    root.render(
      <React.StrictMode>
        {React.createElement(component, props)}
      </React.StrictMode>
    );
  }
};

renderComponent(Auction, 'artifex-auction', {
  wpApiUrl: window.wpApiSettings.wpApiUrl,
  auctionContract: auctionContract,
});

renderComponent(ArtUploader, 'artifex-uploader', {
  wpApiUrl: window.wpApiSettings.wpApiUrl,
  wpNonce: window.wpApiSettings.nonce,
  auctionContract: auctionContract,
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
